/* globals PLUG */
(function (ProductTemplate) {

    "use strict";

    let U;
    let ProductCard;
    let product;

    ProductTemplate.export = function () {
        U = PLUG.import("Utils");
        ProductCard = PLUG.import("ProductCard");
        return Object.freeze({
            init
        });
    };

    function init() {
        console.log("ProductTemplate.init");
        product = JSON.parse(document.getElementById("plug-product-json").innerHTML);
        initRecentlyViewed();
        initRecommendations();

        const bundleJsonScript = document.getElementById("plug-bundle-product-json");
        if (bundleJsonScript) {
            const bundleData = JSON.parse(bundleJsonScript.innerHTML);
            const productForm = document.querySelector("form[data-type='add-to-cart-form']");
            const submitBtn = productForm.querySelector("[type='submit']");

            submitBtn.addEventListener("click", function (event) {
                event.preventDefault();
                event.stopImmediatePropagation();
                console.log("heard");
                const postData = {
                    "items": bundleData.componentProducts.map(componentData => {
                        return {
                            id: componentData.variantId,
                            quantity: componentData.quantity,
                            properties: {
                                "_bundle_product": product.handle
                            }
                        };
                    }),
                    sections: document.getElementsByTagName("cart-notification")[0].getSectionsToRender().map((section) => section.id),
                    sections_url: "/products/" + bundleData.componentProducts[0].handle
                };
                console.log({postData});

                U.makeXmlRequest({
                    method: "POST",
                    url: "/cart/add.js",
                    requestBody: JSON.stringify(postData),
                    headerData: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest",
                        "Accept": "application/json"
                    }
                }, (response, err) => {
                    if (err) throw err;
                    response = JSON.parse(response);
                    if (response.status) {
                      this.handleErrorMessage(response.description);
                      return;
                    }
                    console.log({response});
                    document.getElementsByTagName("cart-notification")[0].renderContents(response);
                });
            });
        }
    }

    function initRecentlyViewed() {
        const section = document.getElementsByClassName("plug-recently-viewed")[0];
        if (!section) {
            return;
        }

        const slider = section.querySelector("plug-product-slider");
        const sliderEle = section.querySelector(".plug-product-slider__slides");
        const placeholderCard = section.getElementsByClassName("plug-product-card--placeholder")[0];
        const cookieName = "textronrecentp";

        slider.addSlideCreationFunction(
            function createSlides(cb) {
                try {
                    getRecentlyViewedProducts(function (products, reason) {
                        if (reason) throw reason;
                        products = products.map(p => JSON.parse(p)).filter((product) => !product.tags.includes("bundle-product"));
                        if (products.length > 0) {
                            const currentProductAlreadyAdded = products.find(p => (p.id === product.id));
                            if (currentProductAlreadyAdded) {
                                if (products.length === 1) {
                                    section.classList.add("is-hidden");
                                    return;
                                }
                                products = products.filter(p => (p.id !== product.id));
                            } else {
                                const handles = products.map(p => p.handle);
                                handles.push(product.handle);
                                console.log({handles});
                                U.setCookie(cookieName, handles.join(","));
                            }

                            const slidesDocFrag = buildSlides(products, placeholderCard);

                            U.removeChildren(sliderEle);

                            return cb(slidesDocFrag);

                        } else {
                            U.setCookie(cookieName, product.handle);
                            section.classList.add("is-hidden");
                        }
                    });
                } catch (exception) {
                    console.log("Error", exception);
                    section.classList.add("is-hidden");
                }
            }
        );

        function getRecentlyViewedProducts(cb) {
            const cookieString = U.getCookie(cookieName);
            if (!cookieString) {
                return cb([]);
            }
            const cookieValue = cookieString.split("=")[1];
            const productHandles = cookieValue.split(",");
            const requestors = productHandles.map(handle => productRequestorFactory(handle));
            U.parallel(requestors)(cb);
        }

        function productRequestorFactory(handle) {
            return function productRequestor(cb) {
                try {
                    U.makeXmlRequest({
                        method: "GET",
                        url: "/products/" + handle + ".js",
                        headerData: { "Content-Type": "application/json" }
                    }, cb);
                } catch (exception) {
                    return cb(undefined, exception);
                }
            };
        }
    }

    function initRecommendations() {
        const section = document.getElementsByClassName("plug-p-recommendations")[0];
        if (!section) {
            return;
        }

        const slider = section.querySelector("plug-product-slider");
        const dataUrl = slider.dataset.url;

        slider.addSlideCreationFunction((cb) => {
            fetch(dataUrl)
                .then(response => response.text())
                .then(text => {
                    const docFrag = document.createDocumentFragment();
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelectorAll(".plug-product-slider__slide");
                    recommendations.forEach(slide => {
                        ProductCard.initListeners(
                            slide.querySelector(".plug-product-card")
                        );
                        docFrag.appendChild(slide);
                    });
                    return cb(docFrag);
                })
                .catch(e => {
                    console.error(e);
                });
        });
    }

    function buildSlides(products, placeholderCard) {
        const docFrag = document.createDocumentFragment();
        products.forEach(prod => {
            docFrag.appendChild(
                buildProductCardSlide(prod, placeholderCard)
            );
        });
        return docFrag;
    }

    function buildProductCardSlide(productData, placeholderCard) {
        const variant = (
            productData.variants.find(variant => variant.available)
            || productData.variants[0]
        );
        console.log({productData});
        const slide = document.createElement("div");
        const card = placeholderCard.cloneNode(true);
        slide.appendChild(card);
        slide.className = "plug-product-slider__slide";
        card.classList.remove("plug-product-card--placeholder");

        const qtyInput = card.getElementsByTagName("plug-quantity-input")[0];
        qtyInput.dataset.variantInventoryManagement = variant.inventory_management;
        qtyInput.dataset.variantInventoryQuantity = variant.inventory_quantity;

        slide.querySelector(".plug-product-card__inner").href = productData.url;

        const titleWithVariant = productData.title + (
            variant.title !== "Default Title"
            ? " - " + variant.title
            : ""
        );

        slide.querySelector(".plug-product-card__title").textContent = titleWithVariant;

        slide.querySelector(".plug-product-card__price").appendChild(
            buildPrice(productData, variant)
        );

        if (productData.variants.length > 1) {
            slide.querySelector(".plug-product-card__quantity").classList.add("is-hidden");
            slide.querySelector(".plug-product-card__add-to-cart-btn").classList.add("is-hidden");
            slide.querySelector(".plug-product-card__view-options").classList.remove("is-hidden");
        } else {
            slide.querySelector(".plug-product-card__add-to-cart-btn").dataset.variantId = variant.id;
        }

        ProductCard.initListeners(
            slide.querySelector(".plug-product-card")
        );

        const img = slide.querySelector(".ratio-img");
        const imageSrc = variant.featured_image || productData.images[0];
        if (imageSrc && imageSrc !== "") {
            img.src = variant.featured_image || productData.images[0];
            img.alt = titleWithVariant;
        } else {
            img.parentElement.removeChild(img);
        }

        return slide;
    }

    function buildPrice(productData, variant/*, showBadges = false*/) {
        // Creates the snippet 'price.liquid' programmatically.
        // ToDo: Add support for badges.

        const priceCents = variant.price;
        const compareAtPriceCents = variant.compare_at_price;

        function buildPriceRegular() {
            const div = document.createElement("div");
            const hiddenLabel = document.createElement("span");
            const price = document.createElement("span");
            div.appendChild(hiddenLabel);
            div.appendChild(price);

            div.className = "price__regular";
            hiddenLabel.className = "visually-hidden visually-hidden--inline";
            hiddenLabel.textContent = "Regular price";
            price.className = "price-item price-item--regular";
            price.textContent = U.formatMoney(priceCents);

            return div;
        }

        function buildPriceSale() {
            const div = document.createElement("div");
            div.className = "price__sale";

            if (productData.price_varies || !product.compare_at_price_varies) {
                const hiddenCompareLabel = document.createElement("span");
                const comparePrice = document.createElement("s");
                const comparePriceWrapper = document.createElement("span");
                div.appendChild(hiddenCompareLabel);
                div.appendChild(comparePriceWrapper);
                comparePriceWrapper.appendChild(comparePrice);
                hiddenCompareLabel.className = "visually-hidden visually-hidden--inline";
                hiddenCompareLabel.textContent = "Regular price";
                comparePrice.className = "price-item price-item--regular";
                comparePrice.textContent = U.formatMoney(compareAtPriceCents);
            }

            const hiddenLabel = document.createElement("span");
            const price = document.createElement("span");
            hiddenLabel.className = "visually-hidden visually-hidden--inline";
            hiddenLabel.textContent = "Sale price";
            price.className = "price-item price-item--sale price-item--last";
            price.textContent = U.formatMoney(priceCents);

            div.appendChild(hiddenLabel);
            div.appendChild(price);

            return div;
        }

        const priceEle = document.createElement("div");
        const priceEleClasses = ["price"];
        if (!variant.available) {
            priceEleClasses.push("price--sold-out");
        }
        if (compareAtPriceCents && compareAtPriceCents > priceCents) {
            priceEleClasses.push("price--on-sale");
        }
        if (
            (!productData.price_varies && productData.compare_at_price_varies)
            || (!productData.compare_at_price)
        ) {
            priceEleClasses.push("price--no-compare");
        }
        priceEle.className = priceEleClasses.join(" ");

        const priceEleInner = document.createElement("div");
        priceEle.appendChild(priceEleInner);
        priceEleInner.appendChild(buildPriceRegular());
        priceEleInner.appendChild(buildPriceSale());

        return priceEle;
    }

})(PLUG.ProductTemplate = Object.create(null));
